import { EventEmitter } from 'events';
export class PromiseFactory {
    constructor() {
        this.container = {
            resolve: () => undefined,
            reject: () => undefined,
            promise: new Promise(() => undefined),
            status: undefined,
            event: new EventEmitter(),
        };
        this.withMultipleBuildProtection();
    }
    static new(config) {
        const builder = new PromiseFactory();
        if (config.timeout) {
            builder.withCancellation(config.timeout);
        }
        if (config.shouldTrackTime) {
            builder.withTimeTracking();
        }
        return builder.build();
    }
    withCancellation(ms) {
        this.container.event.on('build', () => {
            const timeoutPromise = new Promise((_, reject) => {
                setTimeout(() => {
                    this.setPromiseStatus('timeout');
                    reject();
                }, ms);
            });
            this.container.promise = Promise.race([
                this.container.promise,
                timeoutPromise,
            ]);
        });
        return this;
    }
    withTimeTracking() {
        this.container.event.on('build', () => {
            const startTime = performance.now();
            this.container.event.once('done', () => {
                this.container.msTime = performance.now() - startTime;
            });
        });
        return this;
    }
    withEvents(callback) {
        callback(this.container.event);
        return this;
    }
    build() {
        this.container.promise = new Promise((resolve, reject) => {
            this.container.resolve = (...args) => {
                this.setPromiseStatus('success');
                // @ts-ignore
                return resolve(...args);
            };
            this.container.reject = (...args) => {
                this.setPromiseStatus('failed');
                return reject(...args);
            };
        });
        this.container.event.emit('build');
        return this.container;
    }
    withMultipleBuildProtection() {
        let isBuilt = false;
        this.container.event.on('build', () => {
            if (isBuilt) {
                throw new Error('You cannot build more than one promise with the same builder');
            }
            isBuilt = true;
        });
    }
    setPromiseStatus(status) {
        this.container.status = status;
        this.container.event.emit('done');
        this.container.event.emit(status);
    }
}
